import { createContext } from 'react';

interface Context {
  releases: string[];
}

export const ReleasesContext = createContext<Context>({
  releases: [],
});
